<template>
  <div>
    <breadcrumb-component
        :mainTitle="'Billing Invoice'"
        :moduleTitle="'Vlan Cloud'"
        :subTitle="'Invoice'"
    />

    <div class="row">
      <div class="col-md-12">
        <div class="card card_full_window vc_billing_page ">
          <div class="card-body">
            <div class="common_content_wrap no_left_content">
              <div class="d-flex justify-content-between pb_15 border-lightgray-bottom">
                <h5 class="common_subtitle mb_0">Invoice Details</h5>
                <router-link :to="{ name: 'billing' }" class="btn btn-dark btn-sm float-end">Back</router-link>
              </div>
              <div class="common_tab_content">
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="Payment-tab-pane" role="tabpanel"
                       aria-labelledby="Payment-tab" tabindex="0">
                    <div class="vc_billing_invoice mt-4">
                      <div class="row mb_20">
                        <div class="col-md-6">
                          <div class="card">
                            <div class="card-body">
                              <h5 class="common_subtitle pb_15 border-lightgray-bottom mb_0">{{ invoice.month_name }} Summary <br> <span
                                  class="font_12p fw_normal">{{ $moment(invoice.from_date).format('Y-M-D') }} - {{ $moment(invoice.to_date).format('Y-M-D') }}</span></h5>
                              <table class="common_table table w-100 border_none table_no_hover">
                                <tbody>
                                <tr>
                                  <td class="border_none fw_bold">Sub Total</td>
                                  <td class="text-end border_none"><span
                                      class="font_22p color_primary fw_bold">{{ formatPrice(subTotal) }}</span></td>
                                </tr>
                                <tr>
                                  <td colspan="2" class="border_none">
                                    <div class="d_flex_start">
                                      Monthly change <span class="color_primary ml_5 mr_5">
                                      <i v-if="currentMonthlyChange < 0" class="lni lni-arrow-down"></i>
                                      <i v-if="currentMonthlyChange > 0" class="lni lni-arrow-up"></i>
                                    </span> {{ formatPrice(currentMonthlyChange) }}
                                    </div>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                              <div class="additional_service_table">
                                <div class="row">
                                  <div class="col-md-6 pr_20">
                                    <table class="common_table table w-100  table_no_hover mb_0">
                                      <tbody>
                                      <tr>
                                        <td>Additional Service Fee</td>
                                        <td class="text-end">{{ formatPrice(0) }}</td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div class="col-md-6 pl_20">
                                    <table class="common_table table w-100  table_no_hover mb_0">
                                      <tbody>
                                      <tr>
                                        <td>Cloud Service Charge</td>
                                        <td class="text-end">{{ formatPrice(0) }}</td>
                                      </tr>
                                      <tr>
                                        <td>Support Fee</td>
                                        <td class="text-end">{{ formatPrice(0) }}</td>
                                      </tr>
                                      <tr>
                                        <td>Ncloud Discount</td>
                                        <td class="text-end">{{ formatPrice(0) }}</td>
                                      </tr>
                                      <tr>
                                        <td>Sales Commission</td>
                                        <td class="text-end">{{ formatPrice(totalCommission) }}</td>
                                      </tr>
                                      <tr>
                                        <td>Credit</td>
                                        <td class="text-end">{{ formatPrice(0) }}</td>
                                      </tr>
                                      <tr>
                                        <td colspan="2" class="text-end font_18p fw_bold">
                                          {{ formatPrice(totalAmount) }}
                                        </td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div v-if="previousInvoice && previousInvoice?.from_date" class="card">
                            <div class="card-body">
                              <h5 class="common_subtitle pb_15 border-lightgray-bottom mb_0">{{ previousInvoice.month_name }} Summary <br> <span
                                  class="font_12p fw_normal">{{ $moment(previousInvoice.from_date).format('Y-M-D') }} - {{ $moment(previousInvoice.to_date).format('Y-M-D') }}</span></h5>
                              <table class="common_table table w-100 border_none table_no_hover">
                                <tbody>
                                <tr>
                                  <td class="border_none fw_bold">Sub Total</td>
                                  <td class="text-end border_none"><span
                                      class="font_22p color_primary fw_bold">{{ formatPrice(previousInvoice.amount) }}</span></td>
                                </tr>
                                <tr>
                                  <td colspan="2" class="border_none">
                                    <div class="d_flex_start">
                                      Monthly change
                                      <span class="color_primary ml_5 mr_5">
                                      <i v-if="previousMonthlyChange < 0" class="lni lni-arrow-down"></i>
                                      <i v-if="previousMonthlyChange > 0" class="lni lni-arrow-up"></i>
                                    </span>
                                      {{ formatPrice(previousMonthlyChange) }}
                                    </div>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                              <div class="additional_service_table">
                                <div class="row">
                                  <div class="col-md-6 pr_20">
                                    <table class="common_table table w-100  table_no_hover mb_0">
                                      <tbody>
                                      <tr>
                                        <td>Additional Service Fee</td>
                                        <td class="text-end">{{ formatPrice(0) }}</td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div class="col-md-6 pl_20">
                                    <table class="common_table table w-100  table_no_hover mb_0">
                                      <tbody>
                                      <tr>
                                        <td>Cloud Service Charge</td>
                                        <td class="text-end">{{ formatPrice(0) }}</td>
                                      </tr>
                                      <tr>
                                        <td>Support Fee</td>
                                        <td class="text-end">{{ formatPrice(0) }}</td>
                                      </tr>
                                      <tr>
                                        <td>Ncloud Discount</td>
                                        <td class="text-end">{{ formatPrice(0) }}</td>
                                      </tr>
                                      <tr>
                                        <td>Sales Commission</td>
                                        <td class="text-end">{{ formatPrice(previousInvoice.commission_amount) }}</td>
                                      </tr>
                                      <tr>
                                        <td>Credit</td>
                                        <td class="text-end">{{ formatPrice(0) }}</td>
                                      </tr>
                                      <tr>
                                        <td colspan="2" class="text-end font_18p fw_bold">
                                          {{ formatPrice(previousInvoice.total_amount) }}
                                        </td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <h5 class="common_subtitle pb_15 pt_20 mb_0"> Services </h5>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <table class="common_table table table_bordered table_no_hover w-100">
                            <thead>
                            <tr>
                              <th>Name</th>
                              <th>Provider</th>
                              <th>Service Type</th>
                              <th>From</th>
                              <th>To</th>
                              <th>Billing Month</th>
                              <th>Status</th>
                              <th>Total</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="bill in bills" :key="'bill_id_' + bill.id">
                              <td>
                                <template v-if="bill?.cloudServerPrice?.cloud_disk_id">
                                  {{ bill?.cloudServerPrice?.cloud_disk?.name }}
                                </template>
                                <template v-if="bill?.cloudServerPrice?.cloud_network_id">
                                  {{ bill?.cloudServerPrice?.cloud_network?.public_ip }}
                                </template>
                                <template v-if="bill?.cloudServerPrice?.cloud_server_id">
                                  {{ bill?.cloudServerPrice?.cloud_server?.host_name }}
                                </template>
                              </td>
                              <td>{{ bill?.cloud_service?.name }}</td>
                              <td>{{ bill?.service_type }}</td>
                              <td>{{ $moment(bill.from_date).format('Y-M-D h:mm:ss') }}</td>
                              <td>{{ $moment(bill.to_date).format('Y-M-D h:mm:ss') }}</td>
                              <td>{{ bill.billing_date }}</td>
                              <td>{{ bill.status }}</td>
                              <td>{{ formatPrice(bill.total) }}</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbComponent from "@/components/shared/BreadcrumbComponent.vue";

export default {
  name: "PaymentDetails",
  components: {BreadcrumbComponent},
  data() {
    return {
      invoice: '',
      bills: [],
      previousInvoice: null,
      id: this.$route.params.id,
      date: this.$route.params.date,
    }
  },
  computed:{
    currentMonthlyChange() {
      if (this.previousInvoice && this.totalAmount) {
        const previousAmount = this.previousInvoice.total_amount;
        const currentAmount = this.totalAmount;

        if (previousAmount > 0) {
          return (currentAmount - previousAmount);
        }
      }
      return null;
    },
    previousMonthlyChange() {
      if (this.previousInvoice && this.totalAmount) {
        const previousAmount = this.previousInvoice.total_amount;
        const currentAmount = this.totalAmount;

        if (previousAmount > 0) {
          return (previousAmount - currentAmount);
        }
      }
      return null;
    },
    subTotal() {
      if (this.bills?.length) {
        let val = this.bills.reduce((sum, bill) => sum + bill.amount, 0);
        return val
      }
      return 0;
    },
    totalAmount() {
      if (this.bills?.length) {
        let val = this.bills.reduce((sum, bill) => sum + bill.total, 0);
        return val
      }
      return 0;
    },
    totalCommission() {
      if (this.bills?.length) {
        let val = this.bills.reduce((sum, bill) => sum + bill.commission_amount, 0);
        return val
      }
      return 0;
    },
  },
  mounted() {
    this.getInvoiceDetails()
    this.previousMonthBillInvoice()
    this.billingInvoiceServices()
  },
  methods: {
    getInvoiceDetails() {
      this.axios.get(`/generated-payments/${this.id}/${this.date}`)
          .then(({data}) => {
            this.invoice = data.data
          })
    },
    previousMonthBillInvoice() {
      this.axios.get(`/previous-month-generated-payment/${this.date}`)
          .then(({data}) => {
            this.previousInvoice = data
          })
    },
    billingInvoiceServices() {
      this.axios.get(`/billing-invoice-services/${this.date}`)
          .then(({data}) => {
            this.bills = data.data
          })
    }
  }
}
</script>


<style scoped>

</style>